// ClipList.jsx
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteVideoClip } from "../../features/videoClip/videoClipSlice";

export function ClipList({ clips, activeClipId, onSelectClip, loading }) {
  const dispatch = useDispatch();
  const { deleteLoading } = useSelector((state) => state.videoClip);

  const handleDelete = async (e, clip) => {
    e.stopPropagation(); // Prevent triggering the select clip action

    if (!clip.clipId) return; // Only saved clips have clipId

    if (window.confirm("Are you sure you want to delete this clip?")) {
      try {
        await dispatch(deleteVideoClip(clip.clipId)).unwrap();
      } catch (error) {
        console.error("Failed to delete clip:", error);
        alert("Failed to delete clip. Please try again.");
      }
    }
  };
console.log(clips,"clips in clip list");

  // Format duration with milliseconds (e.g., "3.09s")
  const formatDuration = (milliseconds) => {
    // Handle null, undefined, or non-numeric values
    if (milliseconds === null || milliseconds === undefined || isNaN(milliseconds)) {
      return "0.00s";
    }
    const seconds = (Number(milliseconds) / 1000).toFixed(2);
    return `${seconds}s`;
  };

  return (
    <div className="w-full rounded-md border border-slate-800 overflow-hidden flex flex-col bg-slate-900/30 xl:h-[480px] h-auto max-h-[400px] xl:max-h-[480px]">
      <div className="px-4 py-2 text-xs sm:text-sm font-semibold border-b border-slate-800 bg-slate-900/60">
        Clips
      </div>

      <div className="flex-1 overflow-y-auto">
        {loading ? (
          <div className="px-4 py-6 flex items-center justify-center">
            <div className="h-8 w-8 rounded-full border-3 border-slate-600 border-t-slate-200 animate-spin" />
          </div>
        ) : clips && clips.length > 0 ? (
          clips.map((clip) => {
            const isDeleting = deleteLoading[clip.clipId];

            return (
              <div
                key={clip.id}
                className="w-full px-3 sm:px-4 py-2 sm:py-3 border-b border-slate-800/60 text-slate-200 bg-slate-900/20"
              >
                <div className="flex items-start justify-between gap-2">
                  <div className="flex-1">
                    {/* Description */}
                    <p className="text-xs sm:text-sm text-slate-200 leading-snug line-clamp-2 mb-2 font-medium">
                      {clip.description || "No description"}
                    </p>

                    {/* Duration */}
                    <div className="flex items-center gap-1">
                      <span className="text-[11px] sm:text-xs text-slate-400 font-mono">
                        Duration: {formatDuration(clip.duration || (clip.outTime - clip.inTime))}
                      </span>
                    </div>

                    {/* Time Range - Commented out */}
                    {/* <div className="flex items-center gap-2 mb-1">
                      <span className="text-[10px] font-mono text-green-400">
                        {formatTime(clip.inTime)}
                      </span>
                      <span className="text-[10px] text-slate-500">-</span>
                      <span className="text-[10px] font-mono text-red-400">
                        {formatTime(clip.outTime)}
                      </span>
                    </div> */}
                  </div>

                  {/* Delete Button */}
                  {clip.clipId && (
                    <button
                      onClick={(e) => handleDelete(e, clip)}
                      disabled={isDeleting}
                      className="p-1 hover:bg-red-600/20 rounded transition-colors group flex-shrink-0"
                      title="Delete clip"
                    >
                      {isDeleting ? (
                        <div className="h-3 w-3 rounded-full border-2 border-slate-600 border-t-slate-200 animate-spin" />
                      ) : (
                        <svg
                          className="w-3 h-3 text-slate-400 group-hover:text-red-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                          />
                        </svg>
                      )}
                    </button>
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <div className="px-4 py-6 text-center text-slate-400 text-sm">
            No clips available
          </div>
        )}
      </div>
    </div>
  );
}
